import { DataGrid, GridColumns } from '@material-ui/data-grid';
import React from 'react';
import { formatCurrencyAsText } from '~/utils/functions';
import { useMoviProducao } from '../../hooks/useMoviProducao';
import { ContainerTable } from './styles';

export const Table: React.FC = () => {
  const { loadingTable, rows } = useMoviProducao();
  const columns: GridColumns = [
    {
      field: 'num_sequencia',
      headerName: 'Item',
      sortable: false,
      headerAlign: 'left',
      align: 'left',
      disableColumnMenu: true,
      width: 70,
    },
    {
      field: 'cod_produto_producao',
      headerName: 'PLU',
      sortable: false,
      headerAlign: 'left',
      align: 'left',
      disableColumnMenu: true,
      width: 130,
    },
    {
      field: 'des_produto',
      headerName: 'Descrição',
      sortable: false,
      align: 'left',
      headerAlign: 'left',
      disableColumnMenu: true,
      width: 300,
    },
    {
      field: 'des_unidade',
      headerName: 'UN',
      sortable: false,
      headerAlign: 'center',
      align: 'center',
      disableColumnMenu: true,
      width: 70,
    },
    {
      field: 'qtd_producao',
      headerName: 'Qtd. Produção',
      headerAlign: 'left',
      align: 'right',
      sortable: false,
      disableColumnMenu: true,
      width: 170,
      renderCell: (row: any) => {
        return <span>{formatCurrencyAsText(row.row.qtd_producao, 3, 3)}</span>;
      },
    },
    {
      field: 'val_custo_rep',
      headerName: 'Custo Rep.',
      headerAlign: 'left',
      align: 'right',
      sortable: false,
      disableColumnMenu: true,
      width: 150,
      renderCell: (row: any) => {
        return <span>{formatCurrencyAsText(row.row.val_custo_rep)}</span>;
      },
    },
    {
      field: 'val_custo_producao',
      headerName: 'Custo Produção',
      headerAlign: 'left',
      align: 'right',
      sortable: false,
      disableColumnMenu: true,
      width: 180,
      renderCell: (row: any) => {
        return <span>{formatCurrencyAsText(row.row.val_custo_producao)}</span>;
      },
    },
    {
      field: 'tot_qtd_producao',
      headerName: 'Qtd. Total',
      headerAlign: 'left',
      align: 'right',
      sortable: false,
      disableColumnMenu: true,
      width: 150,
      cellClassName: 'greenCell',
      renderCell: (row: any) => {
        return (
          <span>
            {formatCurrencyAsText(row.row.tot_qtd_producao, 3, 3) || '0,000'}
          </span>
        );
      },
    },
    {
      field: 'tot_custo_producao',
      headerName: 'Custo Produção Total',
      headerAlign: 'left',
      align: 'right',
      sortable: false,
      disableColumnMenu: true,
      width: 217,
      headerClassName: 'hideRightSeparator',
      cellClassName: 'greenCell',
      renderCell: (row: any) => {
        return (
          <span>
            R$ {formatCurrencyAsText(row.row.tot_custo_producao, 2, 2 || 0)}
          </span>
        );
      },
    },
  ];

  return (
    <ContainerTable>
      <DataGrid
        style={{ minHeight: '320px' }}
        className="table"
        rows={rows}
        columns={columns}
        loading={loadingTable}
        getRowId={(row) => row.uuid}
        hideFooter
        hideFooterRowCount
        hideFooterPagination
        disableColumnFilter
        disableColumnSelector
        disableColumnMenu
        disableSelectionOnClick
        localeText={{
          noRowsLabel: 'Nenhum registro encontrado....',
          columnMenuLabel: 'Menu',
          columnMenuFilter: 'Filtrar',
          columnMenuHideColumn: 'Esconder',
          columnMenuUnsort: 'Não ordenar',
          columnMenuSortAsc: 'Ordernar ASC',
          columnMenuSortDesc: 'Ordernar DESC',
          columnMenuShowColumns: 'Mostrar columnas',
        }}
      />
    </ContainerTable>
  );
};
